'use client';
import React from 'react';
import { Anchor, AnchorProps } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import MobileAccordion from './_MobileAccordion';

export interface ColumnProps {
  links?: Array<AnchorProps>;
  title: string;
}

interface Props {
  columns: Array<ColumnProps>;
}

const FooterColumn = ({ columns }: Props) => {
  return (
    <div className="grid grid-cols-1 w-full mr-10 mb-10 sm:grid-cols-2 md:gap-x-10 sm:gap-y-4 md:grid-cols-4">
      {columns?.map((col) => (
        <div className="hidden sm:block" key={col.title}>
          <h4 data-testid="mobile-nav-header" className="tra-text-web-sub-2 text-white">
            {col.title}
          </h4>
          <ul className={classNames('list-none pl-3 mb-3 w-full', 'sm:block sm:pl-0')}>
            {col.links?.map((link) => (
              <li key={link?.displayName}>
                <Anchor
                  className={classNames(
                    'tra-text-web-body-s text-neutral-200 block py-2 outline-offset-2',
                    'focus:outline-brand-200 focus:outline-2 focus-visible:outline',
                    'hover:underline hover:text-brand-200',
                  )}
                  {...link}
                  onClick={() => {
                    link.onClick?.(undefined);
                    navigationClicked({
                      nav_type: 'Footer Navigation',
                      clicked_text: link?.displayName ?? '',
                      primary_header: col.title ?? '',
                    });
                  }}
                >
                  {link?.displayName}
                </Anchor>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <MobileAccordion columns={columns} className="list-none sm:hidden" />
    </div>
  );
};

export default FooterColumn;
